import { isNilOrEmpty } from '../../../helpers/utils';

// eslint-disable-next-line
export function getResultsLength(data) {
  if (isNilOrEmpty(data) || !data.topPopularDestination) {
    return 0;
  }
  return (data.popularDestinations || []).length + 1;
}
